import { MissionType } from '@/const/mission';
import { AuditStatusType } from '@/const/status';
import { IChapter, IMission, IScene, IStory } from '@/interface';
import { isWoa } from '@/utils/getApiDomain';

import { AppNode, BotList } from '../types';
import { confirmStory } from './cofirm';
import { disabledStory, isAuthor, nodeCanDelete } from './disabled';
import { turnMissionValue, validateMission } from './validate';

// 故事节点信息（已废弃）
const storyNodeInfo = (node: AppNode, data: IStory) => {
  const isAuth = isAuthor(data.createdBy);
  const status = data?.status || AuditStatusType.STATUS_TYPE_DEFAULT;
  const disabled = disabledStory(status) || isWoa || data.release || !isAuth;
  const botPromptList = data?.botPromptList as BotList[];
  const storyNode: AppNode = {
    ...node,
    data: {
      ...node.data,
      info: confirmStory(data),
      disabled,
      isAuthor: isAuth,
      propsInfo: { // 道具卡解析
        list: getPropsList(data?.itemCardList, botPromptList),
      },
    },
  };
  return storyNode;
};

// 章节节点信息（首节点）
const chapterNodeInfo = (node: AppNode, data: IChapter, story: Partial<IStory>) => {
  const isAuth = isAuthor(data.createdBy);
  const status = story?.status || AuditStatusType.STATUS_TYPE_DEFAULT;
  const disabled = disabledStory(status) || isWoa || data.release || !isAuth;
  const chapterNode: AppNode = {
    ...node,
    data: {
      ...node.data,
      info: data,
      disabled,
      isAuthor: isAuth,
      story,
    },
  };
  return chapterNode;
};

const getPropsList = (list?: IMission[], botPromptList?: BotList[]) => list?.map((e) => {
  // 转换数据道具卡数据转化为剧情结构
  const missionData = turnMissionValue({
    ...e,
    missionType: MissionType.MISSION_TYPE_PROPS,
  });
  // 校验道具卡
  const { isDraft } = validateMission(
    {
      ...missionData,
      missionType: MissionType.MISSION_TYPE_PROPS,
    },
    false,
    botPromptList,
  );
  return ({
    ...missionData,
    id: e?.id || '',
    name: e?.name,
    canDelete: nodeCanDelete(e), // 已发布的不可删除
    isDraft,
  });
}) || [];

// 获取场景下的任务列表
const getMissionDetailToMissionList = (list: IScene['missionList'], type: MissionType) => list?.filter(item => item?.mission?.missionType === type) || [];

export { chapterNodeInfo, getMissionDetailToMissionList, storyNodeInfo };

